import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Post from '../components/Post';
import Footer from '../components/Footer';
import Unauth from '../components/Unauth';
import { CurrentUser } from '../contexts/CurrentUser';

import { useState, useEffect, useContext } from "react"
import {  useParams } from "react-router"

function Topic() {
    const { topicId } = useParams()
    const [topics, setTopics] = useState([]);
    const [firstPost, setFirstPost] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}posts/topic/${topicId}`)
            const resData = await response.json();

            setFirstPost(resData[0])
            setTopics(resData)
        }
        if (topicId) {
            fetchData()
        }
    }, [topicId])

    function onBackButton(e) {
        e.preventDefault();
        window.history.back();
    }

    const topicHeaderText = `${firstPost.forumName} / ${firstPost.postSubject}`;

    const { isLoggedIn } = useContext(CurrentUser);
    if (!isLoggedIn) {
        return <Unauth/>
    }

    return (
        <>
            <Container className='topic'>
                <Row className='topic-header-area'>
                    <Col className='topic-header'>
                        <button 
                            type='button'
                            title={document.referrer || 'Go Back'}
                            className="back-button btn btn-norm"
                            onClick={e => onBackButton(e)}
                        >
                            <i className='fa fa-chevron-left'></i>
                        </button>

                        <h3 className='topic-header-text'  title={topicHeaderText}>{topicHeaderText}</h3>
                    </Col>
                </Row>
                <Row className="scroll-container">
                    <Col className='scrolled-contents'>
                        {topics.map((post, index ) => {
                            return <Post key={post.id} post={post} includeHeader={false}/>
                        })}
                    </Col>
                </Row>
                <Footer/>
            </Container>
        </>
    );
}

export default Topic;